module.exports = __webpack_public_path__ + "static/img/nodata.8f15d587.png";